module.exports = __webpack_public_path__ + "media/images/icons/grey-cross-047e02798be059adf1097a33b5ae75f9.svg";